import { LadzoConsole as Lc } from "../global/ladzo-console.js";

import { TinyDialog } from "@lbgm/tiny-dialog";

function vlozDataDoFormulare(Data, userEmail) {
  Lc.f("vlozDataDoFormulare delivery.js");
  const safeSet = (selector, value) => {
    if (value && $(selector).length) {
      $(selector).val(value);
    }
  };

  Lc.log("Data:", userEmail);
  safeSet("#email", userEmail);
  safeSet("#phone", Data.phone);
  safeSet("#company_reg_id", Data.ico);
  safeSet("#company_vat_id", Data.dic);
  safeSet("#b_company", Data.firma);
  safeSet("#fname", Data.jmeno);
  safeSet("#lname", Data.prijmeni);
  safeSet("#address", Data.ulice);
  safeSet("#city", Data.mesto);
  safeSet("#zip", Data.psc);

  // Zpráva o úspěchu
  //$("#dvAres").text("Údaje byly vyplněny z objektu Data.");
}

function vyplnKontaktniUdaje() {
  Lc.f("vyplnKontaktniUdaje delivery.js");

  let LadzoJsData = window.LadzoJsData || false;
  if (!LadzoJsData) {
    Lc.i("Chybí LadzoJsData");
    return;
  }
  const UserContacts = LadzoJsData.UserContacts || false;
  const address = LadzoJsData.address || false;

  const userEmail = LadzoJsData.UserEmail || false;

  Lc.log("Address:", address);
  if (!UserContacts) {
    Lc.i("Chybí UserContacts v LadzoJsData");
    return;
  }

  if (address) {
    // můžeme v klidu vyplnit formulář nic není vyplněno
    Lc.todo("vyplnit formular dle UserContacts dle hlasky zda prepsat");
    new TinyDialog({
      closeIcon: false,
      title: "Potvrzení",
      content:
        "Chcete přepsat stávající údaje kontaktními údaji z vašeho profilu?",

      buttons: {
        cancel: {
          hide: false,
          className: "btn-cancel",
          text: "Storno",
          action: function () {
            Lc.log("Cancelled");
          },
        },
        ok: {
          className: "btn-ok",
          text: "OK",
          action: function () {
            Lc.log("Confirmed");
            vlozDataDoFormulare(UserContacts, userEmail);
            // Tady smažeš záznam
          },
        },
      },
    });
  } else {
    vlozDataDoFormulare(UserContacts, userEmail);
  }

  Lc.log("LadzoJsData:", LadzoJsData);

  Lc.log("UserContacts:", UserContacts);

  // Okno automaticky zobrazit
  //dialog.open();
}

function zobrazeniProRegistraci() {
  Lc.f("zobrazeniProRegistraci delivery.js");

  $("#chkCreateAccount").on("change", function () {
    if ($(this).is(":checked")) {
      $(".dvPass").slideDown(200);
      $(".inptOko").attr("required", true);
    } else {
      $(".dvPass").slideUp(200);
      $(".inptOko")
        .removeAttr("required")
        .each(function () {
          this.setCustomValidity(""); // zrušit chybu
        });
    }
  });

  // validace shody hesel
  $("input[name='password'], input[name='password_check']").on(
    "input",
    function () {
      kontrolaHesel();
    }
  );
}

function kontrolaHesel() {
  let pass1 = $("input[name='password']")[0];
  let pass2 = $("input[name='password_check']")[0];

  Lc.log("fdas", pass1.value.length);

  // 1) kontrola délky hesla
  if (pass1.value.length > 0 && pass1.value.length < 6) {
    pass1.setCustomValidity("Heslo musí mít alespoň 6 znaků s");
    return; // dál neřešíme, dokud nesplní délku
  } else {
    pass1.setCustomValidity(""); // <<< tohle chybělo
  }

  if (pass1.value !== pass2.value) {
    pass2.setCustomValidity("Hesla se neshodují");
  } else {
    pass2.setCustomValidity("");
  }
}

export function upravStranku() {
  // úpravy stránky doručení
  Lc.f("upravStranku delivery.js");

  const params = new URLSearchParams(window.location.search);

  if (params.has("loaddata")) {
    vyplnKontaktniUdaje();
  }

  zobrazeniProRegistraci();
}
